import { render } from "./PosDashboard.vue?vue&type=template&id=7300f0e8&scoped=true"
import script from "./PosDashboard.vue?vue&type=script&lang=js"
export * from "./PosDashboard.vue?vue&type=script&lang=js"

import "./PosDashboard.vue?vue&type=style&index=0&id=7300f0e8&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7300f0e8"]])

export default __exports__